import React from 'react';
import { SvgIcon, Typography } from '@mui/material';
import { ReactComponent as checkIcon } from 'mui/assets/icons/plus-icon.svg';
import DS_BasicCard from 'mui/components/elements/DS_BasicCard';
import DS_ButtonLink from 'mui/components/elements/DS_ButtonLink';

import { DS_palette as corePalette } from 'mui/base/theme/DS_Tokens/core';
import { StyledAppointmentContent } from '../RescheduleModal/RescheduleModalStyles';
import {
  StyledWrapper,
  StyledCheckIcon,
  StyledDS_ButtonLink,
  StyledSuccessLogin,
  StyledLoaderSpinner,
} from './AuthTokenStyles';

const AuthToken = ({
  userSA,
  bookingData,
  setOpenRescheduleModal,
  openRescheduleModal,
  successLoginMessage,
  existingAppointmentLabel,
  isLoading,
}) => {
  return (
    <StyledWrapper>
      <DS_BasicCard>
        <StyledSuccessLogin>
          <StyledCheckIcon>
            <SvgIcon component={checkIcon} viewBox="0 0 33 33" />
          </StyledCheckIcon>
          <Typography variant="DS_copyMediumBold" component="h3">
            {successLoginMessage || 'You are logged in'}
          </Typography>
        </StyledSuccessLogin>
        <StyledAppointmentContent>
          <Typography variant="DS_copyMediumRegular" component="p">
            {userSA.firstName} {userSA.lastName}
          </Typography>
          <Typography variant="DS_copyMediumRegular" component="p" className="login-email">
            {userSA.email}
          </Typography>
        </StyledAppointmentContent>
        {isLoading && <StyledLoaderSpinner color={corePalette.blue[500]} />}
        {bookingData && (
          <StyledDS_ButtonLink>
            <DS_ButtonLink
              buttonVariant="text"
              buttonSize={false}
              onClick={() => setOpenRescheduleModal(!openRescheduleModal)}
              title={existingAppointmentLabel || 'See existing appointment'}
            ></DS_ButtonLink>
          </StyledDS_ButtonLink>
        )}
      </DS_BasicCard>
    </StyledWrapper>
  );
};

export default AuthToken;
